<section class="follow-feed" dir="rtl" aria-labelledby="feed-title">
  <header class="feed-header">
    <div>
      <span class="feed-header__eyebrow"><i class="fa fa-rss" aria-hidden="true"></i> הפיד האישי שלי</span>
      <h1 id="feed-title">מודעות ממוכרים שאני עוקב אחריהם</h1>
      <p>כל הפרסומים החדשים של המוכרים והחנויות שבחרתם לעקוב אחריהם, במקום אחד.</p>
    </div>
    <span class="feed-count" *ngIf="!loading && ads.length">{{ ads.length }} מודעות נטענו</span>
  </header>

  <div class="feed-filters" *ngIf="!loading && ads.length" aria-label="סינון מודעות">
    <div class="filter-heading">
      <span class="filter-heading__icon"><i class="fa fa-sliders" aria-hidden="true"></i></span>
      <div><strong>סינון לפי קטגוריה</strong><small>בחרו קטגוריה ולאחר מכן תת-קטגוריה</small></div>
    </div>
    <div class="filter-controls">
      <label class="filter-field">
        <span>קטגוריה</span>
        <select [(ngModel)]="selectedCategory" (ngModelChange)="onCategoryChange()">
          <option value="all">כל הקטגוריות</option>
          <option *ngFor="let category of categoryOptions" [value]="category.id">{{ category.name }}</option>
        </select>
      </label>
      <span class="filter-step" aria-hidden="true"><i class="fa fa-angle-left"></i></span>
      <label class="filter-field" [class.filter-field--disabled]="selectedCategory === 'all'">
        <span>תת-קטגוריה</span>
        <select [(ngModel)]="selectedSubcategory" (ngModelChange)="applyFilters()" [disabled]="selectedCategory === 'all'">
          <option value="all">כל תתי-הקטגוריות</option>
          <option *ngFor="let subcategory of subcategoryOptions" [value]="subcategory.id">{{ subcategory.name }}</option>
        </select>
      </label>
      <button type="button" class="clear-filter" *ngIf="selectedCategory !== 'all' || selectedSubcategory !== 'all'" (click)="clearFilters()">
        <i class="fa fa-times" aria-hidden="true"></i> ניקוי סינון
      </button>
    </div>
  </div>

  <div class="feed-state" *ngIf="loading" role="status"><span class="spinner"></span><span>טוענים את הפיד שלכם…</span></div>
  <div class="feed-state" *ngIf="!loading && failed">
    <span class="state-icon"><i class="fa fa-refresh" aria-hidden="true"></i></span><h2>לא הצלחנו לטעון את הפיד</h2><p>בדקו את החיבור ונסו שוב.</p>
    <button type="button" class="feed-button feed-button--secondary" (click)="retry()">נסה שוב</button>
  </div>

  <ng-container *ngIf="!loading && !failed">
    <div class="feed-state" *ngIf="ads.length === 0">
      <span class="state-icon"><i class="fa fa-user-plus" aria-hidden="true"></i></span><h2>הפיד עדיין ריק</h2><p>עקבו אחרי מוכרים וחנויות כדי לראות כאן את המודעות החדשות שלהם.</p>
    </div>

    <div class="feed-state feed-state--compact" *ngIf="ads.length > 0 && filteredAds.length === 0">
      <span class="state-icon"><i class="fa fa-search" aria-hidden="true"></i></span><h2>לא נמצאו מודעות בסינון הזה</h2><button type="button" class="text-button" (click)="clearFilters()">הצג את כל המודעות</button>
    </div>

    <div class="feed-grid" *ngIf="filteredAds.length > 0">
      <article class="feed-card" *ngFor="let ad of filteredAds; trackBy: trackAd" [attr.data-type]="ad.resourcetype">
        <header class="publisher">
          <a class="publisher__identity" [routerLink]="sellerId(ad) ? ['/seller', sellerId(ad)] : null">
            <span class="publisher__avatar">
              <img *ngIf="sellerAvatar(ad)" [src]="sellerAvatar(ad)" [alt]="sellerName(ad)" />
              <span *ngIf="!sellerAvatar(ad)">{{ sellerInitials(ad) }}</span>
            </span>
            <span class="publisher__copy">
              <span class="publisher__name">{{ sellerName(ad) }} <i class="fa fa-check-circle" *ngIf="ad.User?.is_vip_active" title="מוכר VIP"></i></span>
              <small><i class="fa fa-user-check" aria-hidden="true"></i> במעקב</small>
            </span>
          </a>
          <a class="publisher__profile" *ngIf="sellerId(ad)" [routerLink]="['/seller', sellerId(ad)]">לפרופיל <i class="fa fa-angle-left" aria-hidden="true"></i></a>
        </header>

        <a class="ad-media" [routerLink]="['/single', ad.id]">
          <img *ngIf="adImage(ad)" [src]="adImage(ad)" [alt]="ad.name" loading="lazy" />
          <span class="ad-media__empty" *ngIf="!adImage(ad)"><i class="fa fa-picture-o"></i>אין תמונה</span>
          <span class="category-badge">{{ categoryName(ad) }}</span>
          <span class="promoted-badge" *ngIf="ad.adsRoute?.level === 'LEVEL2' || ad.adsRoute?.level === 'LEVEL3'">מודעה מקודמת</span>
        </a>

        <div class="ad-content">
          <a [routerLink]="['/single', ad.id]" class="ad-title"><h2>{{ ad.name }}</h2></a>
          <div class="ad-meta">
            <span *ngIf="ad.year">{{ ad.year }}</span>
            <span *ngIf="ad.ProductStatus?.statusName">{{ ad.ProductStatus.statusName }}</span>
            <span *ngIf="ad.NumberOfOwner?.numberOnwer">{{ ad.NumberOfOwner.numberOnwer }}</span>
          </div>
          <p class="ad-location" *ngIf="cityName(ad)"><i class="fa fa-map-marker" aria-hidden="true"></i>{{ cityName(ad) }}</p>
        </div>

        <footer class="ad-footer">
          <div><small>מחיר</small><strong>{{ adPrice(ad) || 'מחיר בפרטי' }}</strong></div>
          <a [routerLink]="['/single', ad.id]">לצפייה במודעה <i class="fa fa-angle-left" aria-hidden="true"></i></a>
        </footer>
      </article>
    </div>

    <div class="feed-more" *ngIf="hasNext">
      <button type="button" class="feed-button feed-button--secondary" [disabled]="loadingMore" (click)="loadMore()">{{ loadingMore ? 'טוען…' : 'טען מודעות נוספות' }}</button>
    </div>
  </ng-container>
</section>
